import React, { useEffect, useState } from 'react';
import MuiBackdrop from './MuiBackdrop';
import { PageLoadingProvider } from '../contexts/PageLoadingContext';
import useAnimationFrame from '../hooks/useAnimationFrame';

/**
 * @typedef {object} LoaderProps
 * @property {React.ReactNode} children
 */

/**
 * @param {LoaderProps} props
 */
const Loader = props => {
  const { children } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [counter, setCounter] = useState(0);

  const { scheduleAnimationFrame } = useAnimationFrame();

  const incrementLoaderCounter = () => {
    scheduleAnimationFrame(() => {
      setCounter(prev => prev + 1);
    });
  };

  const decrementLoaderCounter = () => {
    scheduleAnimationFrame(() => {
      setCounter(prev => prev - 1);
    });
  };

  const executeWithLoadingIndicator = async callback => {
    incrementLoaderCounter();

    const result = await callback();

    decrementLoaderCounter();

    return result;
  };

  useEffect(() => {
    setIsLoading(counter !== 0);
  }, [counter]);

  return (
    <PageLoadingProvider
      value={{
        incrementLoaderCounter,
        decrementLoaderCounter,
        executeWithLoadingIndicator
      }}>
      <MuiBackdrop open={isLoading} />
      {children}
    </PageLoadingProvider>
  );
};

export default Loader;
